import { getDateTime } from './getDateTime'
import { parseToDate } from './parseToDate'
import { InputDate } from './types/inputDate'

export const getFormattedDateTimeRange = (
  [dateStart, dateEnd]: [InputDate, InputDate],
  locale?: string,
  options?: Intl.DateTimeFormatOptions,
): string => getDateTime(locale, options).formatRange(parseToDate(dateStart) || 0, parseToDate(dateEnd) || 0)
